// Needed to support async await
import React from 'react'
import 'regenerator-runtime/runtime'
import App from './App'
import render from 'commons/js/util/render'
import { init as initReporter } from 'commons/js/util/reporter'
import ScriptLoader from 'commons/js/util/ScriptLoader'
import { googleMapProps } from 'commons/js/components/Map'

initReporter()

const element = document.getElementById('root')

const defaultProps = {
    ...googleMapProps,
    loadingElement: <ScriptLoader />,
}

render({ App, element, props: defaultProps })
